
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";
import ArrowHoveredIcon from "@/components/icons/ArrowIconBlack.vue";
import UIButton from "@/components/button/ui-button.vue";
import GET_ACTIVITIES from "@/apollo/calendar/GetAllActivities.gql";
import GET_PROJECTS from "@/apollo/projects/GetProjectByManagerAndCompanyId.gql";
import GET_CONTRACTOR from "@/apollo/contractors/GetContractorByCompanyId.gql";
import ProjectHeader from "@/components/projects/ProjectHeader.vue";
import NavGrayArrow from "@/components/icons/NavGrayArrow.vue";
import ProfileGray from "@/components/icons/ProfileGray.vue";
import WarningRed from "@/components/icons/WarningRed.vue";
import ClockIcon from "@/components/icons/ClockGray.vue";
import EditTaskAction from "@/components/projects/activities/EditTaskAction.vue";
import LocationGray from "@/components/icons/LocationGray.vue";
import RouteNames from "@/entities/RouteNames";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import EditIconVue from "@/components/icons/EditPenIcon.vue";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageApplications.vue";
import TimesheetTimeTrackerModal from "@/components/projects/timeTracker/TimesheetTimeTrackerModal.vue";
import TimesheetTimeTrackerModalManual from "@/components/projects/timeTracker/TimesheetTimeTrackerModalManual.vue";
import CheckmarkBlack from "@/components/icons/CheckMarkBlack.vue";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
import MultiSelectComponent from "@/components/MultiSelect.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import ChatIcon from "@/components/icons/MsgIcon.vue";
import TableView from "@/components/v2/table/NewTableResource.vue";
import Tooltip from "@/components/common/Tooltip.vue";
import TooltipVariants from "@/entities/TooltipVariants";
import InfoIcon from "@/components/icons/MoreInfoIcon.vue";

import {
  Project_Activity,
  Project_Activity_Time,
  User,
  Company,
  Contractor,
  Timesheet_Order_By,
  Skill,
  Project,
} from "@/generated/graphql";
import moment from "moment";
import GET_COMPANIES from "@/apollo/company/GetCompanies.gql";
import NoDataIcon from "@/components/icons/NoDataIcon.vue";
import PlusIcon from "@/components/icons/PlusIconNew.vue";
import HoveredIcon from "@/components/icons/ArrowIconBlue.vue";
import ActivityFormModal from "@/components/projects/activities/ActivityFormModalNew.vue";
import SuitableResources from "@/components/projects/activities/SuitableResourcesV2.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";
import NotesModal from "@/components/projects/activities/NotesModal.vue";
import CalendarEventModal from "@/components/projects/activities/CalendarEventModal.vue";
import { StyleValue } from "vue";
import DropdownOption from "@/entities/DropdownOption";
import PlusHoveredIcon from "@/components/icons/HoveredIcon.vue";

@Component({
  components: {
    PlusHoveredIcon,
    PlusIcon,
    HoveredIcon,
    ArrowHoveredIcon,
    CalendarEventModal,
    TooltipVariants,
    NotesModal,
    SuitableResources,
    UIButton,
    ChatIcon,
    ActivityFormModal,
    ProjectHeader,
    LoadingOverlay,
    NoDataIcon,
    CrossIcon,
    CrossIconHover,
    VueCal,
    Tooltip,
    ClockIcon,
    ProfileGray,
    LocationGray,
    TableView,
    InfoIcon,
    CheckmarkBlack,
    ArrowIcon,
    NavGrayArrow,
    EditTaskAction,
    TimesheetTimeTrackerModal,
    DropdownFilter,
    EmptyListImageProjects,
    WarningRed,
    TimesheetTimeTrackerModalManual,
    EditIconVue,
    MultiSelectComponent,
  },
  apollo: {
    companies: {
      query: GET_COMPANIES,
      variables() {
        return this.companiesQuery;
      },
      update(data) {
        return data.companies;
      },
    },
    activities: {
      query: GET_ACTIVITIES,
      variables() {
        return this.activitiesArgs;
      },
      update(data) {
        this.activities = data.project_activity;
        return data.project_activity;
      },
    },
    projects: {
      query: GET_PROJECTS,
      variables() {
        return {
          company_id: this.company.id,
          manager_id: this.currentUserManagerId,
        };
      },
      update(data) {
        return data.project;
      },
    },
    resources: {
      query: GET_CONTRACTOR,
      variables() {
        return {
          where: {
            _and: [
              { managers: { manager_id: { _eq: this.currentUserManagerId } } },
              { company_id: { _eq: this.company.id } },
            ],
          },
        };
      },
      update(data) {
        return data.contractor.map((c) => ({
          id: c.id,
          name: `${c.user.given_name} ${c.user.family_name}`,
        }));
      },
    },
  },
})
export default class ContractorTimesheets extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: String, default: undefined })
  readonly currentUserManagerId?: string;

  projectActivityTimes: Project_Activity_Time[] = [];
  projects: Project[] = [];
  resources: { id: string; name: string }[] = [];
  isHovered: boolean = false;
  contractor_activities: Project_Activity[] = [];
  contractor: Contractor = null;
  activeActivity: Project_Activity = null;
  activeTimeEntry: Project_Activity_Time = null;
  eventItems: any[] = [];
  selectedEventNotes: null;
  elapsedTime: number = 0;
  weekStatus: string = null;
  TooltipVariants = TooltipVariants;
  submitTimeModalOpen: boolean = false;
  trackedDate: Date = null;
  orderBy: Timesheet_Order_By[] = [];
  rejectReasonModalOpen: boolean = false;
  weekDisable: boolean = false;
  timerStart: string = null;
  timerEnd: string = null;
  week: Date[] = [];
  activeTabIndex: number = 0;
  minEventWidth = 0;
  totalStaffNotes: number = 0;
  submitTime: boolean = false;
  activeTabIndexRes: number = Number(this.$route.query.tab || 0);
  timeTrackerOpen: boolean = false;
  timeTrackerOpenManual: boolean = false;
  currentCellTime: Date = new Date();
  canPause = false;
  currentPage: number = Number(this.$route.query.page || 1);
  companies?: Company[] = [];
  count: number = 0;
  timeSheetId: string = "";
  limit: number = Number(this.$route.query.limit || 10);

  sortBy = this.$route.query.sort_by || "created_at";
  offset: number =
    this.currentPage >= 1 ? (this.currentPage - 1) * this.limit : 0;
  sortDirection = this.$route.query.sort_direction || null;

  activities?: Project_Activity[] = undefined;
  retryCount: number = 0;
  maxRetries: number = 5;
  showNotesModal: boolean = false;
  selectedEvent: object = {};
  showEventDialog: boolean = false;
  modalEvents: any[];
  showModal: boolean = false;
  activityModalOpened = false;
  isHoveredChat: boolean = false;
  selectedClient: DropdownOption = this.activeActivity
    ? {
        name: this.activeActivity.project.name,
        id: this.activeActivity.project.id,
      }
    : null;

  selectedResource: DropdownOption[] = this.activeActivity
    ? [
        {
          name: this.activeActivity.contractor.user.given_name,
          id: this.activeActivity.contractor.id,
        },
      ]
    : [];

  toggle() {
    this.$router.push({
      name: RouteNames.MANAGE_PROJECTS,
    });
  }

  handleListToggle() {
    this.$router.push({
      name: RouteNames.PROJECT_ACTIVITY,
      params: { id: this.selectedClient.id },
    });
  }

  get currentDate() {
    return this.$moment(new Date()).format("YYYY-MM-DD");
  }
  handleShow(event) {
     this.selectedEventNotes = event;
    this.showNotesModal = true;
  }

  handleClose() {
     this.selectedEventNotes = null;
    this.showNotesModal = false;
  }

  onEventClick(event) {
    if (event.isPlaceholder) {
      this.modalEvents = event.allEvents;
      this.showModal = true;
    }
  }

  onActivityListItemAdded(){
  this.$apollo.queries.activities.refetch();
}

  openActivityModal(): void {
    this.activityModalOpened = true;
  }

  closeActivityModal(): void {
    this.activityModalOpened = false;
  }

  closeModal() {
    this.showModal = false; // Hide the modal
  }

  get isManager(): boolean {
    return this.currentUser.role === "MANAGER";
  }

  get client_option() {
    const selectedClientId = this.$route.query.selectedClientId;
    if (selectedClientId && !this.selectedClient) {
      const client = this.client_options.find(
        (option) => option.id === selectedClientId
      );
      if (client) {
        this.selectedClient = client;
      }
    }
    return [this.selectedClient];
  }

  setClients(input: DropdownOption[]): void {
    this.selectedClient = input[0];
    this.$apollo.queries.activities.refetch();
  }

  get client_options(): DropdownOption[] {
    return this.projects.map((project) => ({
      name: project.client_name,
      id: project.id,
    }));
  }

  get resource_option() {
    return this.selectedResource;
  }

  setResources(input: DropdownOption[]): void {
    this.selectedResource = input;
    this.$apollo.queries.activities.refetch();
  }

  get resource_options(): DropdownOption[] {
    return this.resources;
  }

  handleFilterReset(): void {
    this.selectedClient = null;
    this.selectedResource = [];
    this.$apollo.queries.activities.refetch();
  }

  get activitiesArgs(): object {
    const filters: any[] = [
      { deleted: { _eq: false } },
      {
        project: {
          manager: {
            id: { _eq: this.currentUserManagerId },
          },
        },
      },
    ];
    if (this.selectedClient) {
      filters.push({
        project: {
          id: { _eq: this.selectedClient.id },
        },
      });
    }
    if (this.selectedResource.length) {
      filters.push({
        contractor: {
          id: { _in: this.selectedResource.map((r) => r.id) },
        },
      });
    }
    return {
      where: {
        _and: filters,
      },
    };
  }

  get isTimesheetEmpty() {
    return !!this.activities?.length;
  }

  disableCellClick(event) {
    // event.stopPropagation();
    // event.preventDefault();
  }
  message(event): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: event.assigneeID,
      },
    });
  }
   isNoShow(activity): boolean {
  const currentTime = moment();
  let end_date =activity.end_date || activity.start_date;
  const hasNotCheckedInOrOut =
    activity.checkin_time === null &&
    activity.checkout_time === null;

  if (!hasNotCheckedInOrOut) return false;

  
  if (end_date) {
    const shiftEndDate = moment(end_date).endOf('day');
    if (currentTime.isAfter(shiftEndDate)) return true;
  }

  if (activity.end_time) {
    const shiftEndTime = moment(activity.end_time);
    if (currentTime.isAfter(shiftEndTime)) return true;
  }

  return false;
}
 isNoShowActive(activity): boolean {
  const currentTime = moment();
  let start_time = activity.start_time;
  const hasNotCheckedInOrOut = activity.checkin_time === null

  if (!hasNotCheckedInOrOut) return false;

  
  if (start_time) {
    const timePassed = currentTime.isAfter(start_time);
    if (timePassed) return true;
  }
  return false;
}
  eventClass(event) {
      if (
      !event.completed &&
      !event.drafted &&
      !event.cancelled
    ) {
      if (event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (!event.drafted && this.isNoShowActive(event)) {
        return "NO_SHOW";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (event.accepted === true && !event.checkin_status && !event.checkout_status && !event.completed &&
        !event.drafted &&
        !event.cancelled) {
        return "ACCEPTED";
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if (event.checkin_status === "ON_TIME") {
        return "CLOCKED_IN"; // red
      }
    } else if (
      (event.completed && !event.cancelled && !event.drafted) ||
      (this.isNoShow(event) && event.completed && !event.cancelled && !event.drafted)
    ) {
      if (event.checkout_status === 'OUTSIDE' || event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (!event.drafted && this.isNoShow(event) && !event.completed) {
        return null;
      }
      if (event.checkout_status === "LATE") {
        return "LATE_CLOCK_OUT"                                // after this = late
      }
      if (event.checkout_status === "EARLY") {
        return "EARLY_CLOCK_OUT"; // red
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if ((event.checkout_status === "ON_TIME" && event.checkin_status === "ON_TIME") || (this.isNoShow(event) && event.completed)) {
        return "COMPLETED"; // green
      }
      return 'COMPLETED';

    }
    return "OPEN";
  }
  eventStatus(event) {
    if (
      !event.completed &&
      !event.drafted &&
      !event.cancelled) {
      if (event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (!event.drafted && this.isNoShowActive(event)) {
        return "NO_SHOW";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (event.accepted === true && !event.checkin_status && !event.checkout_status && !event.completed &&
        !event.drafted &&
        !event.cancelled) {
        return "ACCEPTED";
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if (event.checkin_status === "ON_TIME") {
        return "CLOCKED_IN"; // red
      }
      return "OFFERED";
    } else if (
      (event.completed && !event.cancelled && !event.drafted) ||
      (this.isNoShow(event) && event.completed && !event.cancelled && !event.drafted)
    ) {
      if (event.checkout_status === 'OUTSIDE' || event.checkin_status === 'OUTSIDE') {
        return "WRONG_LOCATION";
      }
      if (event.accepted === false) {
        return "DECLINED"; // If the activity is rejected, return "Rejected"
      }
      if (!event.drafted && this.isNoShow(event) && !event.completed) {
        return null;
      }
      if (event.checkout_status === "LATE") {
        return "LATE_CLOCK_OUT"                                // after this = late
      }
      if (event.checkout_status === "EARLY") {
        return "EARLY_CLOCK_OUT"; // red
      }
      if (event.checkin_status === "LATE") {
        return "LATE_CLOCK_IN"; // red
      }
      if (event.checkin_status === "EARLY") {
        return "EARLY_CLOCK_IN"; // red
      }
      if ((event.checkout_status === "ON_TIME" && event.checkin_status === "ON_TIME") || (this.isNoShow(event) && event.completed)) {
        return "COMPLETED"; // green
      }
      return 'COMPLETED';
    }
    return "OPEN";
  }
  isUpcoming(activity): boolean {
    const startTime = this.$moment(activity.start_time);
    const today = this.$moment().startOf("day");
    if (startTime.isAfter(today)) {
      return true;
    }
  }

  initial(event, isManager): string {
    const firstName = !isManager
      ? event.assigneeFirstName
      : event.managerFirstName;
    const lastName = !isManager
      ? event.assigneeFamilyName
      : event.managerFamilyName;

    if (!firstName && !lastName) {
      return "";
    }

    const givenName = firstName ? firstName.trimLeft()[0] : "";
    const familyName = lastName ? lastName.trimLeft()[0] : "";
    return `${givenName}${familyName}`;
  }

  bgStyle(event, isManager): StyleValue {
    return {
      background: hslColorFromName(this.initial(event, isManager) || ""),
      color: "white",
    };
  }

  get events() {
  if (!this.activities?.length) return [];

  // First, transform activities into event objects (keeping all your original properties)
  const allEvents = this.activities.map((activity) => {
    const startTime = activity.start_time
      ? this.$moment(activity.start_time).local()
      : null;
    const endTime = activity.end_time
      ? this.$moment(activity.end_time).local()
      : null;

    const durationInMinutes = endTime
      ? this.$moment(endTime).diff(this.$moment(startTime), "minutes")
      : 0;

    return {
      start: startTime?.format("YYYY-MM-DD HH:mm:ss") || "Invalid Start Time",
      end: endTime?.format("YYYY-MM-DD HH:mm:ss") || "Invalid End Time",
      title: activity.project?.client_name || "N/A",
      location: activity.location,
      virtual: activity.virtual || false,
      virtual_meeting_link: activity.virtual_meeting_link || null,
      fallback_num: activity.fallback_num || null,
      background: true,
      status: this.eventStatus(activity),
      project_activity_skills: activity.project_activity_skills,
      managerFirstName: activity.project.manager?.user?.given_name,
      managerFamilyName: activity.project.manager?.user?.family_name,
      assigneeFirstName: activity.contractor?.user?.given_name,
      assigneeFamilyName: activity.contractor?.user?.family_name,
      resizable: false,
      managerID: activity.project.manager?.user?.id,
      isLessThanHour: durationInMinutes > 0 && durationInMinutes <= 180,
      assigneeID: activity.contractor !== null ? activity.contractor?.user?.id : null,
      class: this.eventClass(activity),
      style: {
        width: `100%`,
        left: `0%`,
      },
      eventId: activity.id,
      showTime: true,
      eventObject: activity,
      notesCount: activity?.contractor_staff_notes_aggregate?.aggregate?.count || 0,
    };
  }).sort((a, b) => {
    // Fix for TypeScript error - compare timestamps instead of Date objects
    const aTime = new Date(a.start).getTime();
    const bTime = new Date(b.start).getTime();
    return aTime - bTime;
  });

  const processedEvents = [];
  const processedEventIds = new Set(); // Track which events we've already processed

  // Function to check if two events overlap
  const eventsOverlap = (event1, event2) => {
    return new Date(event1.start) < new Date(event2.end) && 
           new Date(event1.end) > new Date(event2.start);
  };

  for (let i = 0; i < allEvents.length; i++) {
    if (processedEventIds.has(allEvents[i].eventId)) continue;

    const currentEvent = allEvents[i];
    const overlappingEvents = [currentEvent];

    // Find all events that overlap with the current event
    for (let j = i + 1; j < allEvents.length; j++) {
      if (eventsOverlap(currentEvent, allEvents[j])) {
        overlappingEvents.push(allEvents[j]);
      }
    }

    if (overlappingEvents.length === 1) {
      // No overlaps - show full event with all original properties
      processedEvents.push({
        ...currentEvent,
        style: {
          width: "100%",
          left: "0%",
        }
      });
    } else {
      // Has overlaps - show first event and placeholder
      processedEvents.push({
        ...overlappingEvents[0], // Keep all original properties
        style: {
          width: "70%",
          left: "0%",
        }
      });

      // Add placeholder for remaining events (using first remaining event's properties as base)
      processedEvents.push({
        ...overlappingEvents[1], // Keep all original properties
        title: `+${overlappingEvents.length - 1}`,
        showTime: false,
        class: "placeholder-event",
        isPlaceholder: true,
        allEvents: overlappingEvents.slice(1), // Store all remaining events
        style: {
          width: "20%",
           height: "154px",
          left: "72%",
        }
      });

      // Mark all overlapping events as processed except the first one
      overlappingEvents.slice(1).forEach(event => processedEventIds.add(event.eventId));
    }
  }

  return processedEvents;
}

  requestSkills(event): Skill[] {
    return event.project_activity_skills.map(({ skill }) => skill);
  }

  skillIds(event): number[] {
    return this.requestSkills(event).map(({ id }: Skill) => id);
  }

  contarctorRoute(id) {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: id,
      },
    };
  }
  getWeek($event) {
    this.weekDisable = false; //reset weekDisable
    this.week = [$event.startDate, $event.endDate];
    const calref = this.$refs.vuecalRef as any;
    this.scrollTo9();
    const startTime = new Date($event.startDate).getTime();
    const endTime = new Date($event.endDate).getTime();
    const currentDate = new Date().getTime();
    const isBetween = currentDate <= endTime && currentDate >= startTime;
    this.currentCellTime = isBetween ? new Date() : $event.startDate;
    calref.selectedDate = this.currentCellTime;
  }
  scrollTo9() {
    const calendar = document.querySelector("#vuecal .vuecal__bg");
    const hours = new Date().getHours() + new Date().getMinutes() / 60;
    calendar.scrollTo({ top: hours * 60, behavior: "smooth" });
  }

  get isLoaded(): boolean {
    return (
      this.$apollo.queries?.companies?.loading ||
      this.$apollo.queries?.activities?.loading
    );
  }
  dateRange(view) {
    return `${moment(view.startDate).format("MMM DD")} - ${moment(
      view.endDate
    ).format("MMM DD YYYY")}`;
  }

  get companiesQuery(): Object {
    const conditions: any[] = [
      {
        contractors: {
          user_id: { _eq: this.currentUser.id },
          deleted: { _eq: false },
          approved: { _eq: true },
        },
      },
    ];

    return {
      where: { _and: conditions },
      userId: this.currentUser.id,
    };
  }

  getCurrentTime() {
    return new Date();
  }
}
